import { useEffect, useState } from 'react'
import AOS from 'aos'
import { SITE } from '@/constants'
import Button from '@ui/Button'
import { useLocation } from "react-router-dom";
import { useScrollSpy } from '@helpers/useIntersectionObserver'
import MetaInfo from '@common/MetaInfo'
// ── Section data — real content, swap founder link later ──
const POLICY_SECTIONS = [
  {
    id: 'terms-of-use',
    eyebrow: 'Terms of Use',
    heading: 'Terms of Use',
    paragraphs: [
      <>Your access to and use of this site is subject to the following terms and conditions and all applicable laws. By accessing and using this site, you accept the following terms and conditions, without limitation or qualification.</>,
      'Unless otherwise stated, the contents of this site including, but not limited to, the text, videos, images, documents contained herein and their arrangement are the property of CruxBytes.',
      'Nothing contained in this site shall be construed as conferring by implication, estoppel, or otherwise, any license or right to any copyright, patent, trademark or other proprietary interest of CruxBytes or any third party. This site and the content provided in this site, including, but not limited to, graphic images, audio, video, html code, buttons, and text, may not be copied, reproduced, republished, uploaded, posted, transmitted, or distributed in any way, without the prior written consent of CruxBytes, except that you may download, display, and print one copy of the materials on any single computer solely for your personal, non-commercial use, provided that you do not modify the material in any way and you keep intact all copyright, trademark, and other proprietary notices.',
      'The information provided on this site is free of charge and for informational purposes only and does not create a business or professional services relationship between you and CruxBytes. Links on this site may lead to services or sites not operated by CruxBytes. No judgment or warranty is made with respect to such other services or sites and CruxBytes takes no responsibility for such other sites or services. A link to another site or service is not an endorsement of that site or service. Any use you make of the information provided on this site, or any site or service linked to by this site, is at your own risk.',
      'This site and its contents are provided "as is" and CruxBytes makes no representation or warranty of any kind with respect to this site or any site or service accessible through this site. CruxBytes expressly disclaims all express and implied warranties including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement. In no event will CruxBytes be liable to any party for any direct, indirect, incidental, special, exemplary, consequential, or other damages (including, but not limited to, lost profits, business interruption, loss of programs or data) without regard to the form of action and whether in contract, tort, negligence, strict liability, or otherwise, arising out of or in connection with this site, any content on or accessed through this site or any site service linked to, or any copying, displaying, or use thereof.',
      'You are responsible for complying with the laws of the jurisdiction from which you are accessing this site and you agree that you will not access or use the information on this site in violation of such laws. Unless expressly stated otherwise herein, any information submitted by you through this site shall be deemed non-confidential and non-proprietary. You represent that you have the lawful right to submit such information and agree that you will not submit any information unless you are legally entitled to do so. Because of the open nature of the Internet, we recommend that you not submit information you consider confidential.',
      'CruxBytes does not accept unauthorized idea submissions outside of established business relationships. To protect the interests of our current clients and ourselves, we must treat the issue of such submissions with great care. Importantly, without a clear business relationship, CruxBytes cannot and does not treat any such submissions in confidence. Accordingly, please do not communicate unauthorized idea submissions to CruxBytes through this website. Any ideas disclosed to CruxBytes outside a pre-existing and documented confidential business relationship are not confidential and CruxBytes may therefore develop, use and freely disclose or publish similar ideas without compensating you or accounting to you. CruxBytes will make every reasonable effort to return or destroy any unauthorized idea submissions without detailed review of them. However, if a review is necessary in CruxBytes sole discretion, it will be with the understanding that CruxBytes assumes no obligation to protect the confidentiality of your idea or compensate you for its disclosure or use. By submitting an idea or other detailed submission to CruxBytes through this website, you agree to be bound by the terms of this stated policy.',
    ],
    // stat: { value: 'Since 2010', label: 'Serving clients from Mumbai' },
  },
  {
    id: 'privacy-policy',
    eyebrow: 'Where We are Headed',
    heading: 'Privacy Policy',
    paragraphs: [
      'This website is administered by CruxBytes. The primary purpose of this website to make the information related to technology, services, products available to the prospective clients. We want you to feel secure when visiting our site and are committed to maintaining your privacy when doing so.',
    ],
  },
  {
    id: 'disclaimer',
    eyebrow: 'Disclaimer',
    heading: 'Disclaimer',
    paragraphs: [
      'CruxBytes Consultancy Services maintains this site (the "Site") for your personal information and communication. Please feel free to browse the Site. You may download material displayed on the Site for noncommercial, personal use only, provided you also retain all copyright and other proprietary notices contained on the materials. You may not, however, distribute, modify, transmit, reuse, report, or use the contents of the Site for public or commercial purposes, including the text, images, audio, and video without CruxBytes written permission. Your access and use of the Site is also subject to the following terms and conditions and all applicable laws. By accessing and browsing the Site, you accept, without limitation or qualification, the Terms and Conditions and acknowledge that any other agreement between you and CruxBytes are superseded and of no force or effect.',
     
    ],   
  },

]

function JumpNav({ activeId }) {
  return (
    <nav className="about-jumpnav" aria-label="Policies sections">
      {POLICY_SECTIONS.map(function (section) {
        const isActive = activeId === section.id
        const linkClass = isActive
          ? 'about-jumpnav-link about-jumpnav-link--active'
          : 'about-jumpnav-link'

        return (
          <a key={section.id} href={'#' + section.id} className={linkClass}>
            {section.heading}
          </a>
        )
      })}
    </nav>
  )
}

export default function Policies() {
    const location = useLocation();
  
useEffect(() => {
  AOS.refresh();

  if (location.hash) {
    const id = location.hash.substring(1);

    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  } else {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}, [location.hash]);

  const sectionIds = POLICY_SECTIONS.map((s) => s.id)
  //const activeId = useScrollSpy(sectionIds)
  const activeId   = useScrollSpy(sectionIds, { rootMargin: '-20% 0px -70% 0px' })

  return (
    <><MetaInfo       
         title={`Terms of Use, Privacy Policy & Disclaimer | ${SITE.metaTagPostText}`}
        description="Read the CruxBytes terms of use, privacy policy and disclaimer for this website."
        keywords=""
      />
    <main id="main-content" className="page-wrapper">
      

      <div className="section-py about-us-content">
        <div className="container about-us-layout">
          <aside className="jumpnav-wrap">
            <JumpNav activeId={activeId} />
          </aside>

          <div className="about-us-sections">
            {POLICY_SECTIONS.map((section) => (
              <section key={section.id} id={section.id} className="about-us-section" data-aos="fade-up">
                {/* <span className="impact-eyebrow">{section.eyebrow}</span> */}
                <h2 className="section-heading">{section.heading}</h2>

                {section.paragraphs.map((para, i) => (
                  <p key={i} className="about-us-section-body">
                    {para}
                  </p>
                ))}

                {section.stat && (
                  <div className="about-us-stat">
                    <span className="impact-stat-value">{section.stat.value}</span>
                    <span className="impact-stat-label">{section.stat.label}</span>
                  </div>
                )}

                {section.pills && (
                  <div className="tech-pills about-us-pills">
                    {section.pills.map((pill) => (
                      <span key={pill} className="tech-pill">
                        {pill}
                      </span>
                    ))}
                  </div>
                )}
              </section>
            ))}
          </div>
        </div>
      </div>
    </main>
    </>
  )
}